import React from 'react'
import { Projects } from '../component/Projects'
import { Footer } from '../layout/Footer'
import { Navigationbar } from '../layout/Navigationbar'

export const Projectpage = () => {
  return (
    <div>
        <Navigationbar/>
        <Projects/>
        <Footer/>
        
    </div>
  )
}
